import React from 'react';
import { get } from 'lodash';

import { noop } from 'utils/func';

import GraphicBanner from 'apps/scribe/containers/GraphicBanner';
import RhsBanner from 'apps/scribe/RhsBanner';
import FreeHtmlBanner from 'apps/scribe/containers/FreeHtmlBanner';
import MiniBanners from 'apps/scribe/MiniBanners';
import GraphicBannerWithoutAnalytics from './GraphicBannerWithoutAnalytics';

export function generateGraphicBannerElement(graphicBanner, parentContainer) {
  return graphicBanner ? (
    <GraphicBanner
      parentContainer={parentContainer || {}}
      {...graphicBanner}
    />
  ) : null;
}

export function generateGraphicBannerListWithoutAnalytics({
  classNames, graphicBanners, onClick = noop,
}) {
  return graphicBanners
    ? graphicBanners.map(graphicBanner => {
      if (!graphicBanner || !graphicBanner.docNo) {
        return null;
      }

      return (
        <GraphicBannerWithoutAnalytics
          classNames={classNames}
          key={graphicBanner.docNo}
          onClick={onClick(graphicBanner)}
          {...graphicBanner}
        />
      );
    })
    : null;
}

export function generateGraphicBannerList(graphicBanners, classNames) {
  return graphicBanners
    ? graphicBanners.map(graphicBanner => (
      <GraphicBanner
        key={graphicBanner.docNo}
        classNames={classNames}
        {...graphicBanner}
      />
    ))
    : null;
}

export function generateFreeHtmlElement(freeHtmlFiles, parentContainer) {
  return freeHtmlFiles
    ? freeHtmlFiles.map(freeHtmlFile => (
      <FreeHtmlBanner
        key={freeHtmlFile.docNo}
        {...freeHtmlFile}
        parentContainer={parentContainer}
      />
    ))
    : null;
}

export function generateCatalogueFreeHtmls(scribeContent) {
  if (!scribeContent) {
    return null;
  } else if (scribeContent.eventLandingPage) {
    return generateFreeHtmlElement(scribeContent.eventLandingPage.freeHtmlFiles, scribeContent.eventLandingPage);
  }

  return generateFreeHtmlElement(get(scribeContent, 'landingPage.freeHtmlFiles'), scribeContent.landingPage);
}

export function generateOffersMiniBanners(scribeContent) {
  const { offersLandingPage } = scribeContent;
  return offersLandingPage && offersLandingPage.miniBanners && offersLandingPage.miniBanners.length > 0 ? (
    <MiniBanners
      offersLandingPage={offersLandingPage}
    />
  ) : null;
}

export function generateRhsBanner(rhsBanner, parentContainer) {
  return rhsBanner ? (
    <RhsBanner
      parentContainer={parentContainer}
      banner={rhsBanner}
    />
  ) : null;
}

export function getSeoData(scribeContent) {
  if (!scribeContent) {
    return {
      seoText: null,
      seoTitle: null,
    };
  }
  if (scribeContent.landingPage) {
    const dataForSeo = {
      seoText: get(scribeContent, 'landingPage.seoText') || null,
      seoTitle: get(scribeContent, 'landingPage.seoTitle') || null,
    };
    return dataForSeo;
  }
  if (scribeContent.eventLandingPage) {
    const dataForSeo = {
      seoText: get(scribeContent, 'eventLandingPage.seoText') || null,
      seoTitle: get(scribeContent, 'eventLandingPage.seoTitle') || null,
    };
    return dataForSeo;
  }
  return {
    seoText: null,
    seoTitle: null,
  };
}

